<input type="file" style="display: none" [accept]="accept" (change)="onFileUpload($event)" #fileUpload />

<div class="d-flex">
   <app-select-field
      class="w-100"
      [label]="label"
      [formControl]="formControl"
      [options]="dataSource"
   ></app-select-field>

   <button
      *ngIf="upload"
      class="mt-1 ms-2"
      mat-icon-button
      color="accent"
      (click)="fileUpload.click()"
      [disabled]="isUploading"
   >
      <mat-icon>upload</mat-icon>
   </button>
</div>
